import { useNavigate } from '@tanstack/react-router'
import { PartnerService, UserService } from '@duck/api-definitions'
import { useAuth } from '@/hooks/useAuth'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'
import { InviteHeroCandidate } from './InviteHeroCandidate'

interface InviteGateJoinPublicAssignmentProps {
  details: UserService.InvitationDetails
  token: string
}

export const InviteGateJoinPublicAssignment = ({ details, token }: InviteGateJoinPublicAssignmentProps) => {
  const { t } = useTar()
  const navigate = useNavigate()
  const { joinPublicAssignment, isJoiningAssignment } = useAuth()

  const orgName = details.organizationName ?? ''

  return (
    <div className="w-full max-w-md space-y-6">
      <InviteHeroCandidate
        organizationName={orgName}
        logoURL={details.organizationLogoURL ?? undefined}
        logoCanvas={details.organizationLogoCanvas as PartnerService.OrganizationLogoCanvas | undefined}
        headline={t('invite.publicAssignment.title', { organizationName: orgName })}
        subtitle={t('invite.join.acceptHint')}
      />
      <div className="flex justify-center gap-3">
        <Button
          size="lg"
          onClick={() => joinPublicAssignment(token)}
          disabled={isJoiningAssignment}
          data-testid="invite-accept-assignment"
        >
          {t('invite.join.accept')}
        </Button>
        <Button
          variant="outline"
          size="lg"
          onClick={() => navigate({ to: '/' })}
          disabled={isJoiningAssignment}
          data-testid="invite-decline-assignment"
        >
          {t('invite.join.cancel')}
        </Button>
      </div>
    </div>
  )
}
